import { IPageAction, IPageLink } from "../../../base/models";
import { Link, useParams } from "react-router-dom";

import Dropdown from "react-bootstrap/esm/Dropdown";
import { FC } from "react";
import { MUIIcon } from "../../../widgets";
import { PageLinkHelper } from "../../../base/helpers";
import { Property } from "../../../base/types";
import { useGetProperties } from "../../../base/hooks";

interface IActionDropdownLinkProps {
    action: IPageAction
}

export const ActionDropdownPageLink: FC<IActionDropdownLinkProps> = ({
    action
}) => {
    const { siteId } = useParams()
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageLink: IPageLink = properties[Property.PageLink] || {};

    if (!siteId || !pageLink.pageId)
        return <Dropdown.ItemText>{action.name}</Dropdown.ItemText>

    const pageUrl = PageLinkHelper.getPageLinkUrl(siteId, pageLink);

    return (
        <Dropdown.Item as={() => (
            <Link to={pageUrl} className="dropdown-item">
                {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
                <span>{action.name}</span>
            </Link>
        )} />
    )
}